import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Support from '../Support/Support';
import Paragraph from '../Paragraph/Paragraph';
import ModalButtons from '../Modal/ModalButtons';
import { pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';
import BottomDrawer from '../Drawer/Drawer';

const ValidateAddressesList = styled.ul`
  margin-top;${pxToRem(16)};
  list-style-type: disc;
  padding-left: ${pxToRem(25)};
`;

const ValidateAddressesItem = styled.li`
  margin-bottom: ${pxToRem(14)};
  color: ${themeColors.colorTextSecondary};
  font-size: ${pxToRem(14)};
`;

const ValidateAddressesInfo = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorTextSecondary};
`;

const NoAddress = ({ open, openSupport, isSupportOpen, onBack }) => {
  const { t } = useTranslation();

  if (isSupportOpen) {
    return (
      <BottomDrawer
        isOpen={open}
        onClose={onBack}
        title={t('buyWizard.selectDeliveryAddress')}
      >
        <Support />
      </BottomDrawer>
    );
  }

  return (
    <BottomDrawer
      isOpen={open}
      onClose={onBack}
      title={t('buyWizard.noAddressesTitle')}
    >
      <ValidateAddressesInfo>
        {t('buyWizard.buyForDelivery.chooseDeliveryAddress.validateAddress')}
      </ValidateAddressesInfo>
      <ValidateAddressesInfo marginTop={16}>
        {t('buyWizard.buyForDelivery.chooseDeliveryAddress.validateAddress1')}
      </ValidateAddressesInfo>
      <ValidateAddressesList>
        <ValidateAddressesItem>
          {t('buyWizard.buyForDelivery.chooseDeliveryAddress.validateAddress2')}
        </ValidateAddressesItem>
        <ValidateAddressesItem>
          {t('buyWizard.buyForDelivery.chooseDeliveryAddress.validateAddress3')}
        </ValidateAddressesItem>
      </ValidateAddressesList>
      <ModalButtons
        isVertical
        marginTop
        secondaryButtonProps={{ onClick: onBack, textTransform: 'capitalize' }}
        primaryButtonProps={{
          label: t('buyWizard.common.contactCustomerSupport'),
          onClick: openSupport,
          textTransform: 'capitalize',
        }}
      />
    </BottomDrawer>
  );
};

NoAddress.propTypes = {
  onBack: PropTypes.func,
  openSupport: PropTypes.func,
  isSupportOpen: PropTypes.bool,
  open: PropTypes.bool,
};

export default NoAddress;
